import React from 'react';
import HubPageLayout from '../components/HubPageLayout';
import PinFrame from '../components/PinFrame';

// Threat Battlespace (body title "For Your Situational Awareness.") — the safe-surfing tips, same list the desktop ribbon
// shows under Red Flag Alerts > Safe Surfing > Threat Battlespace (10-01;
// replaced the "can't get there from here" stub). Copy from
// "main app 8-21/2b. Content 2/QA_Safe Surfing.docx", typos corrected.
const TIPS = [
  'Stay ScammerAware when you go online – the ability to perceive, understand, and anticipate how scammers bait you.',
  'All demands for upfront payment to avoid arrest by ANY local, state or federal agency = SCAM.',
  'All legit government websites end with .gov',
  'Unusual payment – cryptocurrency (Bitcoin), gold, silver or other precious metals, gift cards, wire transfers = SCAM.',
  'Never ask for or take investment advice from anyone you met or interact with online.',
  'Any unsolicited email or direct message = SCAM > Do not respond > DELETE.',
  'Update your anti-virus and browser security settings on a weekly basis.',
  'Never allow anyone to control or install software on your computer.',
  'Use a VPN, but understand the limitations it has against scammers.',
  'Understand how to identify social engineering dark psychological manipulation techniques.',
  'If the price is too good to be true – it is.',
  'Out-of-the-blue pop-up virus alerts = SCAM.',
];

// The verdict at the end of a tip ("= SCAM", "SCAM > Do not respond > DELETE")
// is red and bold, as on the desktop panel.
const VERDICT = /(SCAM(?:\s*>\s*[^.>]+)*)/g;

const emphasize = (text) => {
  const nodes = [];
  let last = 0;
  let match;
  VERDICT.lastIndex = 0;
  while ((match = VERDICT.exec(text)) !== null) {
    if (match.index > last) nodes.push(text.slice(last, match.index));
    nodes.push(
      <strong key={match.index} className="text-[#c0271e]">
        {match[1]}
      </strong>
    );
    last = match.index + match[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
};

const ThreatBattlespacePage = () => (
  <HubPageLayout>
    <PinFrame title="For Your Situational Awareness.">
      {/* ml-[38px]: the arrows line up under the pentagon's bottom point. */}
      <ul className="ml-[38px] max-w-4xl space-y-4">
        {TIPS.map((tip) => (
          <li key={tip} className="flex gap-5 text-lg text-black leading-relaxed">
            <span aria-hidden="true" className="flex-shrink-0">&rarr;</span>
            <span>{emphasize(tip)}</span>
          </li>
        ))}
      </ul>
    </PinFrame>
  </HubPageLayout>
);

export default ThreatBattlespacePage;
